// Copyright (c) Meta Platforms, Inc. and affiliates.

import * as stylex from '@stylexjs/stylex';

/**
 * Scoped marker for Switch ancestor selectors.
 * Prevents focus-within and hover styles from leaking from parent containers.
 */
export const switchScope = {
  x1iwu4tg: "x1iwu4tg",
  $$css: true
};